// extracted by mini-css-extract-plugin
export default {"rippleButton":"Button_rippleButton__-qHkI"};